import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import moment from "moment";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { TEACHERS_PAYMENTS_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { ValidationSchema } from "./components/ValidationSchema/ValidationSchema";
import Status from "./components/Buttons/Status";
import SubmitBtn from "./components/Buttons/SubmitBtn";
import InputField from "./components/Inputs/InputField";
import CoursesList from "./components/SelectCollection/CoursesList/CoursesList";
const TeacherPaymentModal = () => {
  const dispatch = useDispatch();
  const { teachersPaymentModalData: modalData } = useSelector(
    (state) => state.teacherPaymentModal
  );
  const { user } = useSelector((state) => state.user);
  const inputNameArr1 = ["fin", "seria", "email", "phone"];

  // formik
  const formik = useFormik({
    initialValues: {
      fullName: modalData.fullName ? modalData.fullName : "",
      fin: modalData.fin ? modalData.fin : "",
      seria: modalData.seria ? modalData.seria : "",
      phone: modalData.phone ? modalData.phone : "",
      birthday: modalData?.birthday ? modalData?.birthday : "",
      courses: modalData?.courses
        ? modalData?.courses.length > 0
          ? "yes"
          : ""
        : "",
      email: modalData?.email ? modalData?.email : "",
      password: modalData?.password ? modalData?.password : "",
    },
    validationSchema: ValidationSchema,
  });
  const setInputValue = useCallback(
    (key, value) =>
      formik.setValues({
        ...formik.values,
        [key]: value,
      }),
    [formik]
  );

  const updateModalState = (keyName, value) => {
    if (keyName === "courses") {
      setInputValue("courses", value.length > 0 ? "yes" : "");
    } else {
      setInputValue(keyName, value);
    }
    dispatch({
      type: TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.GET_TEACHERS_PAYMENTS_MODAL,
      payload: {
        data: { ...modalData, [keyName]: value },
        openModal: true,
      },
    });
  };
  const closeModal = () => {
    dispatch({
      type: TEACHERS_PAYMENTS_MODAL_ACTION_TYPE.GET_TEACHERS_PAYMENTS_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  return (
    <div className="create-update-modal-con teacher-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>{modalData?._id ? "Təlimçi yenilə" : "Təlimçi yarat"}</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          onSubmit={(e) => e.preventDefault()}
          component="form"
          sx={{
            width: 500,
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div className="create-update-modal-form">
            {/* <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              disabled
            >
              <FormControlLabel
                value={"teacher"}
                control={<Radio checked={modalData?.role !== "mentor"} />}
                label="Müəllim"
                disabled
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 13,
                  },
                }}
                onClick={(e) => {
                  // updateModalState("role", "teacher");
                  e.preventDefault();
                }}
                // onClick={() => updateModalState("role", "teacher")}
              />
              <FormControlLabel
                value={"mentor"}
                control={<Radio checked={modalData?.role === "mentor"} />}
                label="Tyutor"
                disabled
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 28,
                  },
                  "& .MuiFormControlLabel-label": {
                    fontSize: 13,
                  },
                }}
                onClick={(e) => {
                  // updateModalState("role", "mentor");
                  e.preventDefault();
                }}
              />
            </RadioGroup> */}
            <InputField
              inputName="fullName"
              formik={formik}
              setInputValue={setInputValue}
              modalData={modalData}
              updateModalState={updateModalState}
            />
            <div className="input-couples">
              {inputNameArr1.map((name, index) => (
                <InputField
                  key={index}
                  inputName={name}
                  formik={formik}
                  setInputValue={setInputValue}
                  modalData={modalData}
                  updateModalState={updateModalState}
                />
              ))}
            </div>

            <CoursesList
              modalData={modalData}
              updateModalState={updateModalState}
              formik={formik}
            />
          </div>
        </Box>

        {!(
          user.role === "worker" &&
          user?.profiles?.find((profile) => profile.profile === "salaries")
            ?.power !== "all"
        ) &&
          (modalData?._id ? (
            <div className="create-update-modal-btn-con">
              <div></div>
              <SubmitBtn
                formik={formik}
                modalData={modalData}
                funcType="update"
                closeModal={closeModal}
              />
            </div>
          ) : (
            <SubmitBtn
              formik={formik}
              modalData={modalData}
              funcType="create"
              closeModal={closeModal}
            />
          ))}

        {modalData?._id && (
          <div className="joined-time">
            Qoşuldu: {moment(modalData.createdAt).format("YYYY.MM.DD")}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeacherPaymentModal;
